// using module.exports here so gatsby-config can read it

process.env.builderAPIKey = process.env.builderAPIKey || '598e82e043a8451ebe5aa431545378ad';

process.env.ENABLE_GATSBY_REFRESH_ENDPOINT=1

module.exports = {
  // TODO: uncomment next line and enter your own public API key
  builderAPIKey: process.env.builderAPIKey
};
